<script>
import Router from '@/router/index.js'
import 'bulma/css/bulma.css'
import modalWindow from '@/components/ModalWindow'
import { getTeamsByTeamIds, getMembersByTeamId, addTeam } from '@/api/FirebaseTeamWrapper.js'
import { countCharacters, hasAdminRole, sortArraybyUpdatedAt } from '@/api/Utilities.js'
import * as constant from '@/constant/constant.js'
// v9 moduler 方式
import { firebaseApp } from '@/firebase.js'
import { getAnalytics, logEvent } from 'firebase/analytics'
import { getMyUserId, getMyUserData } from '@/api/FirebaseUserWrapper.js'
const analytics = getAnalytics(firebaseApp)

export default {
  components: {modalWindow},
  data () {
    return {
      myUserId: '',
      userData: undefined,
      teamsMap: new Map(),
      teamsData: [],
      isCreated: false,
      enableExternalUserWindow: false,
      enableMakeTeamWindow: false,
      alertMakeTeamMsg: '',
      makingTeamName: '',
      makingTeamNameLength: 0,
      title: constant.DEFAULT_DOMAIN_TITLE
    }
  },
  async created () {
    await this.init()
    document.title = 'MyTeams | ' + this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', 'MyTeams | ' + this.title)
    // =================== GOOGLE ANALYTICS ===================
    if (hasAdminRole(this.myUserId)) {
      console.log('YOU ARE DEVELOPPER AND EXCLUDED FROM ANALYSIS')
    } else {
      logEvent(analytics, 'myteams/MyTeams')
    }
    this.isCreated = true
  },
  beforeDestroy () {
    document.title = this.title
    document.querySelector("meta[property='og:title']").setAttribute('content', this.title)
  },
  watch: {
    makingTeamName: function (val) {
      this.makingTeamNameLength = countCharacters(this.makingTeamName)
    }
  },
  methods: {
    async init () {
      this.myUserId = await getMyUserId()
      this.userData = await getMyUserData()
      const teamsOrigin = await getTeamsByTeamIds(this.userData.teams)
      const teams = sortArraybyUpdatedAt(teamsOrigin)
      this.teamsMap = new Map()
      for (const team of teams) {
        const members = await getMembersByTeamId(team.id)
        const targetIndex = members.findIndex(({userId}) => userId === this.myUserId)
        let flag = false
        if (targetIndex !== -1) {
          flag = (members[targetIndex].role === 'owner')
        }
        const teamData = {name: team.teamName, isOwner: flag, members: members}
        if (!team.isDeleted) {
          this.teamsMap.set(team.id, teamData)
        }
      }
      this.teamsData = Array.from(this.teamsMap)
    },
    clickMakeTeam () {
      this.enableMakeTeamWindow = true
      this.alertMakeTeamMsg = ''
      this.makingTeamName = ''
    },
    cancelMakeTeam () {
      this.enableMakeTeamWindow = false
      this.alertMakeTeamMsg = ''
      this.makingTeamName = ''
    },
    async postTeam () {
      // console.log('postTeam')
      this.alertMakeTeamMsg = ''
      const teamName = this.makingTeamName
      if (!teamName) {
        this.alertMakeTeamMsg = '文字を入力してください'
        return
      }
      const msg = teamName
      // console.log('length: ' + msg.length)
      if (msg.length > 20) {
        this.alertMakeTeamMsg = '20文字を超えてます'
        return
      }
      try {
        // teamを作る
        const teamRef = await addTeam(this.makingTeamName)
        this.enableMakeTeamWindow = false
        this.alertMakeTeamMsg = ''
        this.makingTeamName = ''
        Router.push('/editteam/' + teamRef.id)
      } catch (err) {
        this.alertMakeTeamMsg = 'failed!'
        console.error(err)
      }
    }
  }
}
</script>
<style scoped>
.my-teams {
  max-width: 768px;
  margin: auto;
  padding: 1.0rem;
}
.progress{
  margin-top: 10px;
}
.q-bar .columns .column .progress{
  margin-top: 2px;
}
.is-size-8 {
  font-size: 0.55rem !important;
}
.role {
  padding-bottom: 0.45rem;
}
.member {
  background-color: #dbdbdb;
  border-radius: 0.5rem;
}
.owner {
  background-color: #fafafa;
}
.line {
 background-color: #f5f5f5;
 border: none;
 display: block;
 height: 2px;
 margin: 0.8rem 0;
}
</style>
<template>
<div class='my-teams' v-if="isCreated">
  <!-- 新規チームの追加 -->
  <div class="buttons has-addons is-right is-marginless">
    <button class="button is-link is-focused" @click="clickMakeTeam()">
      <span class="icon">
        <i class="fa-solid fa-plus"></i>
      </span>
      <span>新規チーム</span>
    </button>
  </div>
  <div class="maketeam-modal-window">
    <modalWindow @close="cancelMakeTeam()" v-if="enableMakeTeamWindow">
      <template slot="header">
        <div class="buttons is-right">
          <button class="delete" @click="cancelMakeTeam()"></button>
        </div>
      </template>
      <div class='maketeam'>
        <p>チーム名を記入</p>
        <div class="field">
          <div class="control">
            <input v-if="makingTeamNameLength<=20" class="input" placeholder="チーム名" v-model="makingTeamName">
            <input v-else class="input is-danger" placeholder="20文字OVER" v-model="makingTeamName">
          </div>
        </div>
        <div class="q-bar">
          <div class="columns is-mobile is-marginless">
            <div class="column is-three-quarters">
              <div class="add-paddingleft">
                <progress class="progress is-gray is-small" :value="makingTeamNameLength" max="20"></progress>
              </div>
            </div>
            <div class="column is-size-7">残り{{20-makingTeamNameLength}}</div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <div class="buttons is-centered">
          <button class="button" @click="cancelMakeTeam()">キャンセル</button>
          &nbsp;
          &nbsp;
          &nbsp;
          <button class="button is-link" v-if="makingTeamName !=='' && makingTeamNameLength <= 20" @click.once="postTeam()">作成</button>
          <button class="button is-link" v-else @click="postTeam()">作成</button>
        </div>
        <p class="help is-danger has-text-centered">{{alertMakeTeamMsg}}</p>
      </template>
    </modalWindow>
  </div>
  <div class="line"></div>
  <!-- 所属チームの表示 -->
  <div class="team has-text-left" v-for="(team, index) in teamsData" :key="index">
    <div>
      <div>
        <router-link class="text has-text-weight-bold is-size-6" v-bind:to="{ path: '/editteam/' + team[0] }"
        v-if="team[1].isOwner">
          <span class="icon">
            <i class="fa-solid fa-users"></i>
          </span>
          <span>
            {{team[1].name}}
          </span>
        </router-link>
        <div v-else class="text has-text-weight-bold is-size-6">
          <span class="icon">
            <i class="fa-solid fa-users"></i>
          </span>
          <span>
            {{team[1].name}}
          </span>
        </div>
      </div>
      <div>
        <div class="columns is-multiline is-mobile is-marginless">
          <div class="column is-half role">
            <div class="control is-size-8 has-text-left has-text-weight-bold">
              名前
            </div>
          </div>
          <div class="column role">
            <div class="control is-size-8 has-text-right has-text-weight-bold">
              役割
            </div>
          </div>
        </div>
        <div class="member" v-bind:class="{'owner' : team[1].isOwner}">
          <div  v-for="member in team[1].members" :key="member.userId">
            <div class="columns is-multiline is-mobile is-marginless">
              <div class="column is-half">
                <div class="control is-size-7 has-text-left has-text-weight-bold">
                  {{member.name}}
                </div>
              </div>
              <div class="column">
                <div class="control is-size-7 has-text-right has-text-weight-bold">
                  {{member.role}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="line"></div>
    </div>
  </div>
  <div>
    <label class="label has-text-left">権限</label>
    <div class="text is-size-7 has-text-centered">
      <table class="table">
        <thead>
          <tr>
            <th>Category</th>
            <th>Action</th>
            <th>Owner</th>
            <th>Member</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Tree</td>
            <td>作成</td>
            <td>◯</td>
            <td>◯</td>
          </tr>
          <tr>
            <td>Tree</td>
            <td>削除</td>
            <td>◯</td>
            <td>X</td>
          </tr>
          <tr>
            <td>TreeのCard</td>
            <td>作成</td>
            <td>◯</td>
            <td>◯</td>
          </tr>
          <tr>
            <td>TreeのCard</td>
            <td>移動</td>
            <td>◯</td>
            <td>X</td>
          </tr>
          <tr>
            <td>TreeのCard</td>
            <td>編集</td>
            <td>◯</td>
            <td>◯</td>
          </tr>
          <tr>
            <td>TreeのCard</td>
            <td>クリップ</td>
            <td>◯</td>
            <td>◯</td>
          </tr>
          <tr>
            <td>TreeのCard</td>
            <td>色の変更</td>
            <td>◯</td>
            <td>◯</td>
          </tr>
          <tr>
            <td>TreeのCard</td>
            <td>削除</td>
            <td>◯</td>
            <td>X</td>
          </tr>
          <tr>
            <td>Team</td>
            <td>作成</td>
            <td>◯</td>
            <td>◯</td>
          </tr>
          <tr>
            <td>Team</td>
            <td>削除</td>
            <td>◯</td>
            <td>X</td>
          </tr>
          <tr>
            <td>Team</td>
            <td>名前の変更</td>
            <td>◯</td>
            <td>X</td>
          </tr>
          <tr>
            <td>Team</td>
            <td>メンバー追加</td>
            <td>◯</td>
            <td>X</td>
          </tr>
          <tr>
            <td>Team</td>
            <td>ロールの変更</td>
            <td>◯</td>
            <td>X</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>



// WEBPACK FOOTER //
// src/pages/myteams/MyTeams.vue